import mainMenu from './main-menu';

export default {
  mainMenu,
};
